export function calcQuality(auditedCount: number, failedCount: number): number {
    return auditedCount
        ? Math.round((((auditedCount - failedCount) / auditedCount) * 100) * 10) / 10
        : 100;
}

export function calcAllowedBad(total: number, qualityTarget: number): number {
    return Math.round(total * (100 - qualityTarget) / 100);
}

export function calcAfterPenalty(total: number, auditedCount: number, failedCount: number, allowedBad: number, penaltyMultiplier: number): number {
    return total
    - (auditedCount
        ? (Math.max(0, Math.round(+failedCount / +auditedCount * total) - allowedBad)
            * (penaltyMultiplier ?? 0))
        : 0)
}
